export default "__VITE_PUBLIC_ASSET__20948de4__"